import { Link } from "@tanstack/react-router"
import { Lockup } from "@holigral/shared/ui/brand"
import { useLocale } from "@holigral/shared/routing"
import { LanguageSwitcher } from "@/profile"
import { useT } from "@/i18n"

export default function Footer() {
  const { t } = useT("content")
  const locale = useLocale()

  return (
    <footer className="border-t border-border/40">
      <div className="mx-auto flex max-w-250 flex-wrap items-center justify-between gap-4 px-6 py-6 text-sm text-muted-foreground">
        <a
          href="https://holigral.com"
          target="_blank"
          rel="noreferrer noopener"
          aria-label={t("holigral")}
          className="text-foreground"
        >
          <Lockup variant="logo" className="block h-10" />
        </a>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 sm:gap-x-5">
          <Link
            to="/$locale/legal/$slug"
            params={{ locale, slug: "terms" }}
            className="transition-colors hover:text-foreground"
          >
            {t("terms")}
          </Link>
          <Link
            to="/$locale/legal/$slug"
            params={{ locale, slug: "privacy" }}
            className="transition-colors hover:text-foreground"
          >
            {t("privacy")}
          </Link>
          <Link
            to="/$locale/contact"
            params={{ locale }}
            className="transition-colors hover:text-foreground"
          >
            {t("contact")}
          </Link>
          <LanguageSwitcher />
        </div>
      </div>
    </footer>
  )
}
